export default "__VITE_ASSET__BZeGQiTe__"